import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Feature } from '@pxl/models/common';
import { AppRoutingRouteNames } from '@pxl/route-names';
import { FeatureService } from '@pxl/shared/services';

export const featureToggleGuard = (featureName: Feature): CanActivateFn => {
    return (_activatedRoute, _routerState) => {
        const isFeatureHidden = inject(FeatureService).isFeatureHidden(featureName);
        const router = inject(Router);

        return isFeatureHidden ? router.createUrlTree([AppRoutingRouteNames.Dashboard]) : true;
    };
};
